import messages from './locales/startup.json';
import {readPreference,readStorefrontPreference,resolveLanguage,readLastLanguage} from './language';
// Tiny pre-shell copy only; does not import i18next or the merchant application.
export function startupText(key) {
  const user=window.Telegram?.WebApp?.initDataUnsafe?.user;
  let storage;try {storage=window.localStorage;} catch { /* disabled storage */ }
  const language=window.location.pathname==='/admin'?'zh-CN':resolveLanguage(readPreference(storage,user?.id),user?.language_code,readLastLanguage(storage,user?.id));
  return messages[language][key]??messages[language].missing;
}
export function storefrontStartupText(key){
  const user=window.Telegram?.WebApp?.initDataUnsafe?.user;let storage;try{storage=window.localStorage;}catch{}
  const language=resolveLanguage(readStorefrontPreference(storage,user?.id),user?.language_code,readLastLanguage(storage,user?.id));
  return messages[language][key]??messages[language].missing;
}
// Public guide URL language is independent of personal account preferences.
export function publicStartupText(key){
  const requested=new URLSearchParams(window.location.search).get('lang');
  const language=window.location.pathname==='/reception-guide'?(requested==='en'?'en':'zh-CN'):(requested==='zh-CN'?'zh-CN':'en');
  return messages[language][key]??messages[language].missing;
}
